module.exports = __webpack_public_path__ + "494cd07c/img/revit-icon.5ff0d581.svg";